module.exports = __webpack_public_path__ + "media/images/smart_phone/btn_demo_gifu_off-063d4bdf628d7b2678c0f2ac80c42119.png";